import { t } from "@lingui/macro";
import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import { ExecutionFee } from "domain/synthetics/fees";
import { GmSwapFees } from "domain/synthetics/trade";

import { GmFees } from "components/Synthetics/GmSwap/GmFees/GmFees";
import { NetworkFeeRow } from "components/Synthetics/NetworkFeeRow/NetworkFeeRow";
import { SyntheticsInfoRow } from "components/Synthetics/SyntheticsInfoRow";

import { Operation } from "../types";

export function InfoRows({
  isDeposit,
  fees,
  executionFee,
}: {
  isDeposit: boolean;
  fees: GmSwapFees | undefined;
  executionFee: ExecutionFee | undefined;
}) {
  const [isExecutionDetailsOpen, setIsExecutionDetailsOpen] = useState(false);

  const toggleExecutionDetails = () => {
    setIsExecutionDetailsOpen(!isExecutionDetailsOpen);
  };

  return (
    <div className="mb-12 flex w-full justify-between gap-8 px-4">
      <NetworkFeeRow rowPadding executionFee={executionFee} />
      <GmFees
        operation={isDeposit ? Operation.Deposit : Operation.Withdrawal}
        totalFees={fees?.totalFees}
        swapFee={fees?.swapFee}
        swapPriceImpact={fees?.swapPriceImpact}
        uiFee={fees?.uiFee}
      />
      {/* 
      <SyntheticsInfoRow label={t`Execution Details`} onClick={toggleExecutionDetails}>
        {isExecutionDetailsOpen ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
      </SyntheticsInfoRow> */}
      {/* {isExecutionDetailsOpen ? <NetworkFeeRow rowPadding executionFee={executionFee} /> : null} */}
    </div>
  );
}
